
// userMsg 点击用户头像
// 查看不同用户个人中心
export const userMsg = {
	state: {
    userMsg: null
	},
	mutations: {
    setUserMsg (state, payload) {
      if (typeof payload === 'object') {
        state.userMsg = payload
      } else {
        throw TypeError(`payload: ${payload} is not a object`)
      }
    }
	},
	actions: {
    
	},
	getters: {
    userMsg: state => state.userMsg,
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/user-msg/index.js